import { create } from "zustand";
import { toast } from "react-toastify";

/* =======================
   TYPE (FORM)
======================= */
export type SkillForm = {
  skillName: number; // id skill
};

/* =======================
   STORE
======================= */
type SkillState = {
  loading: boolean;
  updateSkills: (data: SkillForm[]) => Promise<boolean>;
};

const getAccessToken = (): string | null => {
  if (typeof window === "undefined") return null;

  try {
    const raw = localStorage.getItem("auth-storage");
    if (!raw) return null;

    const parsed = JSON.parse(raw);
    return parsed?.state?.accessToken || null;
  } catch (e) {
    console.error("❌ Failed to parse auth token:", e);
    return null;
  }
};

export const useSkillStore = create<SkillState>((set) => ({
  loading: false,

  updateSkills: async (data) => {
    try {
      set({ loading: true });

      const token = getAccessToken();
      if (!token) throw new Error("No access token");

      const payload = {
        skill_ids: data.map((s) => Number(s.skillName)),
      };

      const res = await fetch(
        "https://admin-talentlink.digiline.id/api/candidate/skills",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(payload),
        }
      );

      if (!res.ok) throw new Error("Update skills failed");

      toast.success("Skills updated successfully");
      return true;
    } catch (err) {
      console.error(err);
      toast.error("Failed to update skills");
      return false;
    } finally {
      set({ loading: false });
    }
  },
}));
